export const HEADER_HEIGHT = "5rem"
export const SIDEBAR_WIDTH = "300px"
